// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0b1d5aa3","692":"81a2cd62","884":"46bdb8ba"}[chunkId] + ".chunk.js";
};